module.exports = __webpack_public_path__ + "static/Averta-Regular-77d35f0394ae76ad85b81c1857533472.woff2";